import { cx } from "../../lib/cx.js";
import { IconButton } from "../IconButton/IconButton.js";
import { useOptionalBrand } from "../ThemeRoot/BrandContext.js";
import { useAppShell } from "./AppShellContext.js";
import { BrandMark } from "../BrandMark/BrandMark.js";
/* empty css           */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AppShell/TopBar.tsx
/**
* The bar across the top of the app: the sidebar toggle, the brand and product name,
* page context, and the user menu. Inside an AppShell it wires the toggle to the
* shell's sidebar.
*/
function TopBar({ brand, productName: productNameProp, onToggleSidebar, sidebarOpen, sidebarId, toggleLabel = "Toggle navigation", children, actions, className, ...rest }) {
	const shell = useAppShell();
	const brandConfig = useOptionalBrand();
	const sidebarHasBrand = shell?.brandPlacement === "sidebar" && !shell.narrow;
	const onToggle = onToggleSidebar ?? (sidebarHasBrand ? void 0 : shell?.toggleSidebar);
	const expanded = sidebarOpen ?? shell?.sidebarOpen;
	const controls = sidebarId ?? shell?.sidebarId;
	const defaultName = brandConfig?.productName;
	const productName = sidebarHasBrand ? null : productNameProp === void 0 ? defaultName : productNameProp;
	const brandNode = sidebarHasBrand ? null : brand === void 0 ? brandConfig && /* @__PURE__ */ jsx(BrandMark, { size: "sm" }) : brand;
	return /* @__PURE__ */ jsxs("header", {
		...rest,
		className: cx("ds-top-bar", shell && `ds-top-bar--brand-${shell.brandPlacement}`, shell?.narrow && "ds-top-bar--narrow", className),
		children: [
			onToggle && /* @__PURE__ */ jsx(IconButton, {
				className: "ds-top-bar__toggle",
				icon: "menu",
				size: "lg",
				"aria-label": toggleLabel,
				"aria-expanded": expanded,
				"aria-controls": controls,
				onClick: onToggle
			}),
			(brandNode || productName) && /* @__PURE__ */ jsxs("div", {
				className: "ds-top-bar__brand",
				children: [brandNode, productName && /* @__PURE__ */ jsx("span", {
					className: "ds-top-bar__product",
					children: productName
				})]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "ds-top-bar__context",
				children
			}),
			actions && /* @__PURE__ */ jsx("div", {
				className: "ds-top-bar__actions",
				children: actions
			})
		]
	});
}
//#endregion
export { TopBar };

//# sourceMappingURL=TopBar.js.map